import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { FiUploadCloud, FiSettings, FiLogOut, FiImage, FiGrid, FiUsers } from 'react-icons/fi';

const AdminDashboard = () => {
  const { logout, role } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="max-w-6xl mx-auto py-8">
      <div className="flex justify-between items-center mb-8 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <div>
          <h1 className="text-3xl font-bold text-gray-800">Admin Dashboard</h1>
          <p className="text-gray-500 mt-1">Manage your Epaper content securely.</p>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 px-4 py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition duration-200 font-medium"
        >
          <FiLogOut /> Logout
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Upload Epaper Card */}
        <Link to="/admin/upload" className="block group">
          <div className="h-full bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 group-hover:border-blue-200">
            <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors duration-300">
              <FiUploadCloud className="text-2xl text-blue-600 group-hover:text-white transition-colors duration-300" />
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">Upload Epaper</h2>
            <p className="text-gray-500">
              Upload a new PDF epaper with a specific date and publish it to the platform.
            </p>
          </div>
        </Link>

        {/* Manage Epapers Card */}
        <Link to="/admin/manage" className="block group">
          <div className="h-full bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 group-hover:border-purple-200">
            <div className="w-14 h-14 bg-purple-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-purple-600 transition-colors duration-300">
              <FiSettings className="text-2xl text-purple-600 group-hover:text-white transition-colors duration-300" />
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2 group-hover:text-purple-600 transition-colors">Manage Epapers</h2>
            <p className="text-gray-500">
              View, edit, or delete existing epapers. Keep your content organized and up-to-date.
            </p>
          </div>
        </Link>
        
        {/* Upload Ad Card */}
        <Link to="/admin/upload-ad" className="block group">
          <div className="h-full bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 group-hover:border-green-200">
            <div className="w-14 h-14 bg-green-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-green-600 transition-colors duration-300">
              <FiImage className="text-2xl text-green-600 group-hover:text-white transition-colors duration-300" />
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2 group-hover:text-green-600 transition-colors">Upload Ad</h2>
            <p className="text-gray-500">
              Upload new image advertisements to display on the Home page.
            </p>
          </div>
        </Link>

        {/* Manage Ads Card */}
        <Link to="/admin/manage-ads" className="block group">
          <div className="h-full bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 group-hover:border-orange-200">
            <div className="w-14 h-14 bg-orange-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-orange-600 transition-colors duration-300">
              <FiGrid className="text-2xl text-orange-600 group-hover:text-white transition-colors duration-300" />
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2 group-hover:text-orange-600 transition-colors">Manage Ads</h2>
            <p className="text-gray-500">
              View, toggle, or delete existing advertisements.
            </p>
          </div>
        </Link>
        
        {/* Chairman Desk Card - Only visible to Chairman */}
        {role === 'chairman' && (
          <Link to="/admin/editors" className="block group">
            <div className="h-full bg-slate-900 p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-800 group-hover:border-red-500 relative overflow-hidden">
              <div className="absolute -right-4 -top-4 w-24 h-24 bg-red-600 rounded-full opacity-10 group-hover:scale-150 transition-transform duration-500"></div>
              <div className="w-14 h-14 bg-slate-800 rounded-xl flex items-center justify-center mb-6 group-hover:bg-red-600 transition-colors duration-300 relative z-10">
                <FiUsers className="text-2xl text-white transition-colors duration-300" />
              </div>
              <h2 className="text-2xl font-bold text-white mb-2 group-hover:text-red-400 transition-colors relative z-10">Chairman Desk</h2>
              <p className="text-slate-400 relative z-10">
                Manage editor accounts. Add or remove editors who can oversee epapers and advertisements.
              </p>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
